module.exports = __webpack_public_path__ + "img/browser_firefox.b65a4744.svg";